var c = Object.defineProperty;
var h = (a, r, e) => r in a ? c(a, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[r] = e;
var s = (a, r, e) => (h(a, typeof r != "symbol" ? r + "" : r, e), e);
import { Popup as _ } from "mapbox-gl";
const m = (a) => {
  for (const r of a.values()) {
    const e = r.match(/mapboxgl-popup-anchor-(.+)/);
    if (e)
      return e[1].replace("-", " ");
  }
  return "";
};
class f extends _ {
  constructor(e) {
    super(e);
    s(this, "_map", null);
    s(this, "_wrapperContainer");
    s(this, "_container");
    s(this, "_content");
    s(this, "_lngLat");
    s(this, "_anchor");
    /*
     * If clicking on a feature visible on a pickable deck.gl layer, the onClick event will propagate
     * on both deck.gl and on the mapbox map. Deck.gl cannot stop this since they are separate libraries.
     * Since this click will count *twice*, the popup will call the "open" event then immediately call
     * the "remove" event, so a popup will never show appear on the map on a clickable deck.gl layer.
     *
     * _handleDeckGLDoubleClick will ignore this "second" click, then allow for a "third" click to then remove the popup
     */
    s(this, "_handleDeckGLDoubleClick");
    this._handleDeckGLDoubleClick = e.handleDeckGLDoubleClick;
  }
  addTo(e) {
    return this._map && this._remove(), super.addTo(e);
  }
  _remove() {
    if (this._handleDeckGLDoubleClick) {
      this._handleDeckGLDoubleClick = !1;
      return;
    }
    const e = this._wrapperContainer;
    e && e.parentNode && (e.parentNode.removeChild(e), delete this._wrapperContainer), super.remove();
  }
  remove() {
    return this._remove(), this;
  }
  _update() {
    const e = this._lngLat || this.trackPointer;
    if (!this._map || !e || !this._content)
      return;
    const i = this._map._requestDomTask;
    let n = this._wrapperContainer, t = this._container, p;
    Object.defineProperty(this, "_container", {
      configurable: !0,
      get: () => t,
      set: (o) => {
        var l;
        n = this._wrapperContainer = document.createElement("div"), n.className = "mapboxgl-popup-wrapper", n.style.position = "absolute", n.style.pointerEvents = "none", n.style.zIndex = "2", t = o, t && (t.style.position = "relative", (l = this._map) == null || l.getContainer().appendChild(n), n.appendChild(t));
      }
    }), this._map._requestDomTask = (o) => {
      i.call(this._map, () => {
        p = t ? t.style.transform : "scale(0)", o(), t && n && (n.style.transform = t.style.transform, t.style.transform = p, t.style.transformOrigin = this._anchor ? this._anchor.replace("-", " ") : m(t.classList));
      });
    }, super._update(), delete this._container, this._container = t, this._map._requestDomTask = i;
  }
}
export {
  f as AnimatedMapboxPopup
};
//# sourceMappingURL=index.es438.js.map
